import { Map, Record } from "immutable";
import { RootActions, RootState } from "common/reducers";
import { receive } from "common/reducers/Utils";
import { eagleviewProductFromJSON, EagleviewProductRecord } from "common/records/EagleviewProduct";
import {
  EagleviewProductActions,
  RECEIVE_EAGLEVIEW_PRODUCT,
  RECEIVE_EAGLEVIEW_PRODUCTS,
} from "common/reducers/eagleviewProduct.actions";

export const EagleviewProductsStateRecord = Record({
  lastSavedById: Map<number, EagleviewProductRecord>(),
  byId: Map<number, EagleviewProductRecord>(),
});

export const initialState = EagleviewProductsStateRecord();

const model = "eagleviewProducts";

export const reducer = (state: RootState, action: RootActions): RootState => {
  if (state && !state.get(model)) {
    state = state.set(model, initialState);
  }

  switch (action.type) {
    case RECEIVE_EAGLEVIEW_PRODUCT:
      return receive(state, model, eagleviewProductFromJSON(action.payload.eagleviewProduct));

    case RECEIVE_EAGLEVIEW_PRODUCTS:
      action.payload.eagleviewProducts.forEach((eagleviewProduct) => {
        state = reducer(state, EagleviewProductActions.receiveEagleviewProduct(eagleviewProduct));
      });
      return state;

    default:
      return state;
  }
};
